// @ts-ignore
import UAParser from 'ua-parser-js';
import { satisfies, compareVersions } from 'compare-versions';
import { some } from 'lodash-es';

export const ua = UAParser();

export const iosVersion = Number(ua.os.version);

let iosIsUnder13Let = ua.os.name === 'iOS' && iosVersion && iosVersion < 13;
if (process.env.NODE_ENV !== 'production') iosIsUnder13Let = false;
export const iosIsUnder13 = iosIsUnder13Let;

console.log(ua);

const baseVersionMap = {
  android: {
    type: 'android',
    browser: 'chrome',
    baseVersion: 80,
  },
  ios: {
    type: 'ios',
    browser: 'safari',
    baseVersion: 13,
  },
  ipad: {
    type: 'ipad',
    browser: 'safari',
    baseVersion: 13,
  },
  mac: {
    type: 'mac',
    browser: 'chrome',
    baseVersion: 72,
  },
  windows: {
    type: 'windows',
    browser: 'chrome',
    baseVersion: 72,
  },
};

const androidDisableUa = ['mailapp', 'MailMaster']; // 安卓和ios不支持的ua
const isDisabledBrowser = () => {
  return some(androidDisableUa, (item) => ua.ua?.match(item));
};

export function checkBrowerAble() {
  if (!ua.os.name) return 'chrome';
  const osName = ua.os.name.toLowerCase();
  if (['mac os', 'mac'].includes(osName)) {
    if (ua.ua?.match(/popo/i)) return 'safari';
    if (ua.browser.name?.match(/safari|chrome/i)) {
      return '';
    }
    return 'safari';
  }
  if (['ios'].includes(osName)) {
    if (ua.ua?.match(/popo/i)) return 'safari';
    if (ua.browser.name?.match(/safari/i)) {
      return '';
    }
    return 'safari';
  }
  if (osName === 'android') {
    if (ua.ua?.match(/popo/i)) return 'chrome';
    if (ua.browser.name?.match(/chrome/i)) {
      return '';
    }
    return 'chrome';
  }
  if (osName === 'windows') {
    if (ua.ua?.match(/popo/i)) return 'chrome';
    if (ua.browser.name?.match(/chrome|edge/i)) {
      return '';
    }
    return 'chrome';
  }
  return 'chrome';
}

export function checkBrowser({
  browser,
  baseVersion,
}: {
  browser: string;
  baseVersion: number | string;
}) {
  return (
    ua.browser.name?.match(RegExp(browser, 'i')) &&
    ua?.browser?.version &&
    compareVersions(ua?.browser?.version || '0', String(baseVersion)) > -1
  );
}

export function satisfiesBrowser({
  browser,
  baseVersion,
}: {
  browser: string;
  baseVersion: number | string;
}) {
  return (
    ua.browser.name?.match(RegExp(browser, 'i')) &&
    satisfies(ua.browser.version, String(baseVersion))
  );
}

export function checkBrowerAble2() {
  if (!ua.os.name) return baseVersionMap.windows;
  const osName = ua.os.name.toLowerCase();
  if (window.isPad) {
    if (checkBrowser(baseVersionMap.ipad)) {
      return null;
    }
    return baseVersionMap.ipad;
  }
  if (['mac os', 'mac'].includes(osName)) {
    if (ua.ua?.match(/popo/i)) return baseVersionMap.mac;
    if (checkBrowser(baseVersionMap.mac)) {
      return null;
    }
    return baseVersionMap.mac;
  }
  if (['ios'].includes(osName)) {
    if (ua.ua?.match(/popo/i)) return baseVersionMap.ios;
    if (checkBrowser(baseVersionMap.ios) && !isDisabledBrowser()) {
      return null;
    }
    return baseVersionMap.ios;
  }
  if (osName === 'android') {
    if (ua.ua?.match(/popo/i)) return baseVersionMap.android;
    if (checkBrowser(baseVersionMap.android) && !isDisabledBrowser()) {
      return null;
    }
    return baseVersionMap.android;
  }
  if (osName === 'windows') {
    if (ua.ua?.match(/popo/i)) return baseVersionMap.windows;
    if (checkBrowser(baseVersionMap.windows)) {
      return null;
    }
    return baseVersionMap.windows;
  }
  return baseVersionMap.windows;
}

export const checkBrowerResult = checkBrowerAble2();

export const deviceData = {
  browser: ua.browser.name,
  browserVersion: ua.browser.version,
  os: ua.os.name,
  osVersion: ua.os.version,
};

export const nativeCheck = (function () {
  let nativeType = 'web';
  if (ua.ua.match('POPOMeeting')) {
    nativeType = 'POPOMeeting';
  }
  const version = ua.ua.match(/popoversion_((\d+\.?){2,3})/)?.[1] || '';
  return {
    nativeType,
    version,
  };
})();
